import React, { useState, useEffect } from "react";
import "./FacultyPrograms.css";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";

const STTPPrograms = () => {
  const years = [
    "2025-26",
    "2024-25", "2023-24", "2022-23", "2021-22", 
    "2020-21", "2019-20", "2018-19", "2017-18", 
    "2016-17", "2015-16"
  ];

  const yearData = {
        "2025-26": {
  title: "Academic Quality Enhancement through Outcome-Based Education (OBE) and Emerging Domains",
  duration: "14 Days",
  dates: "June 16 – 29, 2026",
  association: "ISTE Approved STTP",
  mode: "Hybrid",
  overview1: "The Two-Week ISTE Approved Short Term Training Programme (STTP) on Academic Quality Enhancement through Outcome-Based Education (OBE) and Emerging Domains engaged 30 teaching faculty members and 14 non-teaching staff members. The programme aimed to strengthen participants' understanding of Outcome-Based Education (OBE), curriculum design, assessment methodologies, accreditation practices, research publication, holistic well-being, and emerging technologies in higher education.",
  overview2: "Through expert lectures, hands-on curriculum development activities, wellness sessions, research-oriented discussions, collaborative assignments, and practical Artificial Intelligence workshops, the STTP successfully fostered a culture of continuous learning, collaboration, innovation, and quality enhancement aligned with NBA, NAAC, and NEP 2020.",
  sessions: [
    {
      dayTitle: "Day 1 (16th June 2026): Outcome-Based Curriculum Development & Gap Analysis",
      points: [
        "Inaugural ceremony followed by the Institute Specific Training Programme on Outcome-Based Curriculum Development and Assessment for Computer Applications.",
        "Dr. Jagannath P. Tegar (NITTTR Bhopal) introduced OBE concepts, quality assurance, NBA accreditation, NEP implementation, and the transition to competency-based education.",
        "Dr. Seema Verma (NITTTR Bhopal) guided participants through analyzing the existing MCA curriculum to identify gaps regarding industry expectations and curriculum modernization.",
      ],
    },
    {
      dayTitle: "Day 2 (17th June 2026): Learning Outcomes & Articulation Matrices",
      points: [
        "Dr. Jagannath P. Tegar detailed the systematic formulation of measurable Course Outcomes (COs) using Bloom's Taxonomy aligned with PEOs and UGC guidelines.",
        "Dr. Seema Verma introduced the Course Articulation Matrix (CAM) and Programme Articulation Matrix (PAM) through practical exercises mapping COs with POs and PSOs.",
      ],
    },
    {
      dayTitle: "Day 3 (18th June 2026): Complex Engineering Problems & Learner-Centred Pedagogies",
      points: [
        "Dr. Jagannath P. Tegar explained Complex Engineering Problems (CEPs) based on Washington Accord guidelines, sustainability principles, and real-world problem statements.",
        "Dr. Seema Verma presented learner-centered pedagogies (PBL, flipped classrooms, experiential learning) and sample curricula integrating SDGs.",
      ],
    },
    {
      dayTitle: "Day 4 (19th June 2026): Outcome-Based Assessment & Rubrics Development",
      points: [
        "Dr. Jagannath P. Tegar covered effective assessment, Design of Specification Table (DST), and aligning tools with COs across Assessment of/for/as Learning.",
        "Dr. Seema Verma demonstrated techniques for assessing higher-order cognitive skills and creating comprehensive rubrics for labs, projects, and presentations.",
      ],
    },
    {
      dayTitle: "Day 5 (20th June 2026): Outcome Attainment & Closing the Loop",
      points: [
        "Dr. Jagannath P. Tegar explained calculating CO, PO, and PSO attainment using direct/indirect methods and implementing corrective actions via the Closing the Loop process.",
        "Session concluded with an achievement test, participant feedback, and the valedictory session for the 5-day Institute Specific Training segment.",
      ],
    },
    {
      dayTitle: "Day 6 (22nd June 2026): Departmental Curriculum Design Workshop",
      points: [
        "Departmental assignment activities focused on reviewing/revising COs and CAMs for MCA and Integrated MCA Programmes.",
        "Aligned academic documentation and curriculum structures with NBA accreditation standards and NEP guidelines.",
      ],
    },
    {
      dayTitle: "Day 7 (23rd June 2026): Yoga & Holistic Wellness / Curriculum Refinement",
      points: [
        "Dr. Sharon Wu conducted a Yoga and Wellness Session featuring postures, breathing exercises, and mindfulness for physical fitness and stress management.",
        "Teaching faculty refined curriculum documentation, assessment plans, CAMs, and PAMs during the afternoon workshop.",
      ],
    },
    {
      dayTitle: "Day 8 (24th June 2026): Research Paper Publication & Q1 Journal Strategies",
      points: [
        "Morning session dedicated to completing curriculum design documentation for OBE implementation.",
        "Dr. Swati Chopade (Former Head MCA, VJTI) delivered an expert talk on Research Paper Publication: From Idea to Q1 Journal Acceptance, covering research gaps, Scopus/Web of Science indexing, manuscript writing, and peer review ethics.",
      ],
    },
    {
      dayTitle: "Day 9 (25th June 2026): Staff Team-Building & Well-Being",
      points: [
        "Staff Team-Building Picnic organized at Silent Hill Resort for teaching and non-teaching participants to foster collaboration, communication, and interpersonal relationships.",
      ],
    },
    {
      dayTitle: "Day 10 (29th June 2026): Practical AI Workshop & Valedictory Session",
      points: [
        "Mr. Nakul Chamariya (Senior Data Scientist, MySellerCentral) conducted a hands-on workshop on AI Agents, LLMs, RAG, vector databases, and workflow automation in academic processes.",
        "STTP concluded with a Valedictory Session and Certificate Distribution Ceremony marking the successful completion of the two-week program.",
      ],
    },
  ],
  tools: ["OUTCOME-BASED EDUCATION (OBE)", "BLOOMS TAXONOMY", "CAM & PAM MAPPING", "AI AGENTS & RAG", "LLMS & VECTOR DATABASES", "SCOPUS / Q1 PUBLICATION"],
  outcome: "Participants enhanced their competencies in implementing Outcome-Based Education, formulating measurable learning outcomes, designing CO-PO attainment matrices, publishing high-impact research, adopting student-centric pedagogies, and integrating emerging Generative AI workflows into academic administration.",
},
    "2024-25": {
      title: "Information Technology for Sustainability – Green AI",
      duration: "14 Days",
      dates: "June 17-30, 2025",
      association: "ISTE & CSI Mumbai Chapter",
      mode: "Hybrid",
      overview1: "The STTP proved to be a holistic and impactful program, blending technical expertise with spiritual and wellness dimensions. Engaging 23 teaching staff and 13 non-teaching staff, it successfully enhanced professional competencies while promoting sustainable and green IT practices.",
      overview2: "The initiative not only enriched participants' knowledge but also fostered a culture of environmental responsibility and overall well-being, paving the way for future capacity-building efforts.",
      sessions: [
        {
          dayTitle: "Day 1 (17th June 2025): Digital Identity & Secure Cloud Computing",
          points: [
            "Dr. Ashwini Renavikar delivered an insightful session on Digital Identity for Research, emphasizing the importance of implementing digital identity systems in academic and research contexts.",
            "Dr. Arvind Dangi from Manav Rachna University conducted a session on Secure and Sustainable Cloud Computing, exploring challenges in Green IT through real-world case studies.",
          ],
        },
        {
          dayTitle: "Day 2 (18th June 2025): Deep Learning & LLM Implementation",
          points: [
            "Mr. Nakul Chamariya, Senior Data Scientist at Folsippy, introduced the basics of deep learning with platforms like ChatGPT, Gemini, and Copilot, explaining encoder-decoder architecture and transformers.",
            "Hands-on implementation of Large Language Models (LLMs) in Google Colab, along with an overview of useful online resources for integrating LLMs into daily workflows.",
          ],
        },
        {
          dayTitle: "Day 3 (19th June 2025): RAG & AI Agents",
          points: [
            "Deep learning session focusing on Retrieval-Augmented Generation (RAG) and cosine similarity in LLMs, explained using LangChain-based examples.",
            "Introduction to AI agents including single, network, supervisor, hierarchical, and custom agents, with hands-on project using Wikipedia data and LangGraph demonstration.",
          ],
        },
        {
          dayTitle: "Day 4 (20th June 2025): International Yoga Day Celebration",
          points: [
            "TIMSCDR celebrated the 11th International Yoga Day with Ms. Shikha Verma, a certified Yoga Instructor, who conducted a rejuvenating session on asanas and wellness.",
            "Free ECG health check-up organized by the Aditya Birla Group for all staff members.",
          ],
        },
        {
          dayTitle: "Day 5 (23rd June 2025): Green Technology for Renewable Energy",
          points: [
            "Mr. Vikas Gupta, VP at Bajet Project Ltd., delivered a session on Harnessing Green Technology for Renewable Energy, discussing sustainability, ecological balance, green software practices, and the circular IT economy.",
          ],
        },
        {
          dayTitle: "Day 6 (24th June 2025): Software Innovation & MATLAB Integration",
          points: [
            "Dr. Madhulika Bangre, Indian Patent Agent, led a session on Securing Software Innovation, covering intellectual property rights and patent filing processes.",
            "Mr. Kunal Khandelwal from MathWorks Pune conducted a hands-on workshop on Enhancing Dataset Diversity, focusing on MATLAB-Python integration and code conversion techniques.",
          ],
        },
        {
          dayTitle: "Day 7 (25th June 2025): Explainable AI",
          points: [
            "Mr. Khandelwal explored Explainable AI, showcasing the use of pre-trained deep learning models on Google Colab, and emphasizing customization for research applications.",
          ],
        },
        {
          dayTitle: "Day 8 (26th June 2025): Professional Certifications & Knowledge Program",
          points: [
            "Teaching staff completed self-paced certification courses offered by Elsevier's Researcher Academy, earning credentials in professional development.",
            "Prof. Mira Gohil conducted a reflective session titled 3D Program of Knowledge, blending ancient literature with mindfulness and meditation.",
          ],
        },
        {
          dayTitle: "Day 9 (27th June 2025): Elsevier Certification & AI Enterprise Applications",
          points: [
            "Staff continued self-paced certification courses from Elsevier's Researcher Academy.",
            "Mr. Rahul Tiwari, Senior Consultant at Microsoft, delivered a session on From LLM to AI, exploring real-world enterprise AI applications and intelligent transformation strategies.",
          ],
        },
        {
          dayTitle: "Day 10 (30th June 2025): Research Paper Writing & Project Proposals",
          points: [
            "Dr. Varun Menon from SCM5 Group delivered a session on Writing High-Quality Research Papers, discussing trending research areas like GenAI, LLMs, Federated AI, Edge Computing, Quantum Computing, and Neuromorphic Computing.",
            "Dr. Vinod from CUSAT presented on Funded Project Proposal Writing, highlighting evaluation criteria, proposal structuring, and funding opportunities such as MSCA.",
          ],
        },
      ],
      tools: ["MATLAB", "PYTHON", "GOOGLE COLAB", "LANGCHAIN", "LANGGRAPH", "CHATGPT", "GEMINI"],
      outcome: "Faculty gained deeper insight into AI technologies, understanding their potential in healthcare and sustainability, and gained confidence to build predictive models using MATLAB and modern AI frameworks. The program successfully promoted green IT practices and overall well- wellbeing.",
    },
    "2023-24": {
      title: "Information Technology in Agriculture and Healthcare for Sustainability – Viksit Bharat",
      duration: "12 Days",
      dates: "June 18-29, 2024",
      association: "ISTE & CSI Mumbai Chapter",
      mode: "Hybrid",
      overview1: "TIMSCDR conducted a 2-week ISTE approved Short Term Training Program (STTP), in association with CSI, Mumbai Chapter. The theme of this year's STTP was Information Technology in Agriculture and Healthcare for Sustainability – Viksit Bharat.",
      overview2: "The STTP started with our Director, Dr. Vinita Gaikwad's address, welcoming all delegates and participants. The first day featured thrilling team-building activities at Sajan Resort.",
      sessions: [
        {
          dayTitle: "Day 1: Staff Training & Team-building",
          points: [
            "The first day at Sajan Resort was packed with thrilling activities, fun, and team bonding.",
          ],
        },
        {
          dayTitle: "Day 2: Yoga & Sahaja Meditation",
          points: [
            "Rejuvenating yoga session led by Ms. Supriya Baikerikar with physical postures, breathing exercises, and mindfulness practices.",
            "Ms. Vineeta Gupta conducted a session on achieving work-life balance through Sahaja Yoga Meditation, explaining the subtle system, chakras, and kundalini energy.",
          ],
        },
        {
          dayTitle: "Day 3: Intellectual Property Rights & Nutrition",
          points: [
            "Dr. Bharat Suryawanshi led a workshop on copyrights, patents, trademarks, and the patent application process.",
            "Dr. Yelloji Mirajkar presented on the 'Aahaar Kranti' initiative, discussing India's carbohydrate-centric diet impact on health. Dr. Rashmi Kulkarni highlighted balanced nutrition, while Dr. Srinivasa K. Rao discussed biofortification under the 'Poshan Abhiyan' scheme.",
          ],
        },
        {
          dayTitle: "Day 4: Digital Marketing & Water Management",
          points: [
            "Mr. Rajesh Patalia discussed digital marketing, focusing on its importance, technological impact, and ethical practices in the digital age.",
            "Dr. Seema Jagtap highlighted traditional water management techniques from ancient India, advocating for integrating sustainable practices with modern methods.",
          ],
        },
        {
          dayTitle: "Day 5: Sustainability & NEP Implementation",
          points: [
            "Mrs. Sonal Desai's session on 'Plastic RRR' stressed reducing, recycling, and reusing plastic to support sustainability with practical tips.",
            "Dr. Rajesh Bansode discussed the implementation of the National Education Policy (NEP) for postgraduate programs, emphasizing reducing illiteracy and improving employability.",
          ],
        },
        {
          dayTitle: "Day 6-7: MATLAB Workshop",
          points: [
            "Mr. Kunal Khandelwal provided an overview of MATLAB's programming constructs and applications for data processing, visualization, and statistical analysis.",
            "Demonstrated MATLAB's visualization functions, guiding participants in creating 2D and 3D plots, including line graphs, scatter plots, histograms, and surface plots.",
          ],
        },
        {
          dayTitle: "Day 8: Design Thinking Workshop",
          points: [
            "Ms. Devanshi Sihare from Tinker Labs led a workshop on Design Thinking, introducing the lifecycle—Empathize, Define, Ideate, Prototype, Test, and Iterate using case studies.",
            "Participants tackled case studies on reducing screen time and mitigating sleep disorders, fostering creativity and problem-solving skills.",
          ],
        },
        {
          dayTitle: "Day 9: Conservation & AI in Healthcare",
          points: [
            "Mr. and Mrs. Afzal Khatri discussed water and land conservation, emphasizing India's water crisis and sustainable management practices.",
            "Ms. Anjali Mogare explored AI's role in healthcare, covering advancements in diagnostics, personalized treatments, and drug discovery.",
          ],
        },
        {
          dayTitle: "Day 10: Research Proposals & Digital Presence",
          points: [
            "Dr. Umakant Butkar from VB Solutions discussed crafting effective research proposals, stressing societal relevance and clear goals.",
            "Dr. Butkar focused on enhancing digital presence through Google Scholar, ResearchGate, and LinkedIn, and suggested YouTube for outreach.",
          ],
        },
      ],
      tools: ["MATLAB", "DESIGN THINKING TOOLS", "AI PLATFORMS", "DIGITAL MARKETING TOOLS"],
      outcome: "At the valedictory function, certificates were awarded to all participants by Director Dr. Vinita Gaikwad. Faculty gained comprehensive knowledge of IT applications in agriculture and healthcare for sustainable development.",
    },
    "2022-23": {
      title: "Information Technology – Women Empowerment",
      duration: "12 Days",
      dates: "May 29 - June 9, 2023",
      association: "ISTE & CSI Mumbai Chapter",
      mode: "Hybrid",
      overview1: "TIMSCDR conducted a 2-week ISTE approved Short Term Training Program (STTP), in association with CSI, Mumbai Chapter from May 29, 2023 – June 9, 2023. The theme of this year's STTP was Information Technology – Women Empowerment.",
      overview2: "The program emphasized health as the greatest wealth and started with sessions on diet, professional development, and quality assurance in education.",
      sessions: [
        {
          dayTitle: "Day 1 (May 29): Diet & Nutrition Session",
          points: [
            "Ms. Anupama Singh Padhi, Founder CEO at Dhaani Foods, discussed physical, social, and mental health with 7 habits to a healthy lifestyle.",
            "Introduced Dr. Khadar Vali's work in reviving 'Siridhanya' (positive millets) and shared various millet recipes.",
            "All faculty members took the online course of MATLAB Fundamentals covering data analysis, visualization, modeling and programming.",
          ],
        },
        {
          dayTitle: "Day 2 (May 30): CO-PO Mapping",
          points: [
            "Dr. Kamal Shah, VP at TCET, conducted a session on CO-PO mapping, discussing PO attainment and bridging gaps.",
            "Explained CO mapping to revised Bloom's Taxonomy with current semester subject data for calculating CO-PO mapping values.",
          ],
        },
        {
          dayTitle: "Day 3 (May 31): Annual Quality Assurance Report (AQAR)",
          points: [
            "Dr. Rajesh Bansode, Professor in IT department at TCET, explained how AQAR is filled and discussed IQAC composition.",
            "Emphasized the alignment of the Academic Calendar and Institute Calendar, and explained criteria-wise important points for NAAC.",
          ],
        },
        {
          dayTitle: "Day 4 (June 1): MATLAB for Data Processing and Visualization",
          points: [
            "Mr. Ankit Kumar from Design Tech Systems explained Analysis and Visualization with Vectors, Matrices, Tables of Data, and Conditional Data Selection.",
            "Faculty members successfully completed hands-on activities and scored certificates in the MATLAB Fundamental course.",
          ],
        },
        {
          dayTitle: "Day 5 (June 2): Strategy Management & Kitchen Waste Management",
          points: [
            "Dr. Mukesh Gupta, Founder director LeNest, spoke on Strategic Management and Porter's Five Forces model application in education.",
            "Mrs. Bhagyashree Chemburkar explained Kitchen Waste Management, segregation of dry and wet waste, and making compost.",
          ],
        },
        {
          dayTitle: "Day 6 (June 3): INSEED NGO Visit & AI Tools",
          points: [
            "Entire staff visited INSEED NGO and Adiwasi village in Janu Pada with Dr. Sangeeta Shirname to understand the challenges of underprivileged communities.",
            "Second session on AI tools organized by Be10X covered tools for presentations, email management, research paper reading, and Excel automation.",
          ],
        },
        {
          dayTitle: "Day 7-8 (June 4-5): Teacher Training for Student Success",
          points: [
            "Mr. Sunil Parekh, International success coach & NLP practitioner, conducted a 2-day session on 'How can a teacher be trained to get best out of students'.",
            "Discussed Law of Attraction, Law of Resonance, conscious and subconscious mind, and the seven steps to success formula.",
          ],
        },
        {
          dayTitle: "Day 9 (June 7): Yoga & Brahma Kumaris Sessions",
          points: [
            "Ms. Madhu, a yoga trainer, demonstrated stretching exercises and Asanas for strengthening the vertebral column under 'Har Ghar Aangan Yoga' and 'One Yoga for One World' themes.",
            "Ms. Sandhya Sister spoke on the Purpose of Life, and Ms. Kavita Sister on Mindset for Changing Times.",
          ],
        },
        {
          dayTitle: "Day 10 (June 8): Research Paper Writing",
          points: [
            "Dr. Shilpi Shah MSNIM discussed 'How to write effective Research Paper', covering Bibliometric Analysis and Prisma Analysis.",
            "Demonstrated using the SCOPUS website to search papers on IEEE and introduced VOSVIEWER software for constructing bibliometric networks.",
          ],
        },
        {
          dayTitle: "Day 11 (June 9): Field Trip",
          points: [
            "All faculty and staff enjoyed a field trip to Monteria Village at Kalote Khalapur, Raigad district.",
            "Experienced Giant Swing, Pottery, Khat Weaving, boating, swimming, rain dance, farm tour, biogas plant, and vermicompost plant visit.",
          ],
        },
      ],
      tools: ["MATLAB", "VOSVIEWER", "AI TOOLS", "SCOPUS", "IEEE"],
      outcome: "The Valedictory function was honored with the presence of Director Dr. Vinita Gaikwad. Certificates were distributed to all participants who gained comprehensive knowledge on women empowerment through IT and professional development.",
    },
    "2021-22": {
      title: "Information Technology for Sustainability – Carbon Neutrality",
      duration: "12 Days",
      dates: "June 6-17, 2022",
      association: "ISTE & CSI Mumbai Chapter",
      mode: "Hybrid",
      overview1: "TIMSCDR conducted a 2 week ISTE approved STTP in association with CSI, Mumbai Chapter from 6 – 17 June 2022. The theme of this year's STTP was Information Technology for Sustainability- Carbon Neutrality.",
      overview2: "The STTP started with Director Dr. Vinita Gaikwad's address welcoming all delegates and participants. She conducted a session on 'Towards Carbon neutrality', discussing global warming, net zero carbon emission, action needed by 2030 and sustainable development goals.",
      sessions: [
        {
          dayTitle: "Day 1-2 (June 6-7): AWS Cloud Computing Workshop",
          points: [
            "Mr. Shridhar Galande conducted a workshop on AWS Cloud Computing, discussing AWS services and distributed IT infrastructure.",
            "Covered Infrastructure as a Service (IaaS), Platform as a Service (PaaS), AWS EC2, AWS S3, and hands-on exercises on IAM roles for granting access to AWS accounts.",
          ],
        },
        {
          dayTitle: "Day 3 (June 8): Sustainability & Innovative Teaching",
          points: [
            "Ms. Priti Bhandari, Founder Alchemei-Environment Initiatives, explained carbon generation in daily uses and how to control emissions at an individual level.",
            "Mr. Aniket Pate from Kwality Infosolution explained innovative teaching methods using a Smart board.",
            "Energy Literacy Training from Energy Swaraj Foundation on alternative sources of energy and efficient home appliances.",
          ],
        },
        {
          dayTitle: "Day 4 (June 9): Art of Living & Universal Human Values",
          points: [
            "Prerna Khandelwal, Life Skills Trainer & Life coach, conducted a session on 'Art of living' discussing stress and the 7 layers of existence.",
            "Ms. Anjali conducted Yoga Asana with eye, mind and neck stretching exercises.",
            "Dr. Mohan B. Rao discussed Universal Human Values and Carbon Neutrality, sharing experiences of Korea and Bhutan's holistic approach.",
          ],
        },
        {
          dayTitle: "Day 5 (June 10): Field Trip to Saguna Baug",
          points: [
            "Mr. Shekhar Bhatsawale conducted an interactive session on carbon sequestration and gave in-depth knowledge on climate change and human activities' role.",
            "Discussed Saguna Rice Techniques (SRT) for cultivating rice without plowing, puddling and transplanting on permanent raised beds.",
          ],
        },
        {
          dayTitle: "Day 6 (June 13): Yoga & Course Outcomes",
          points: [
            "Mr. Gopal Krishna Jha conducted a full body workout yoga session for all staff members.",
            "Ms. Sonu Gupta explained the institute's vision and mission, and how to deal with syllabus, co-curricular and extra-curricular activities to achieve PEO, PO and CO Mapping.",
          ],
        },
        {
          dayTitle: "Day 7 (June 14): Carbon Neutrality Workshop",
          points: [
            "Ms. Vedangi Sohni discussed how carbon offsets balance out emissions and explained direct and indirect ways of energy consumption.",
            "Highlighted how digital transformation has a positive impact on fighting climate change and reducing CO2 emissions.",
          ],
        },
        {
          dayTitle: "Day 8 (June 15): Sustainability & Global Warming",
          points: [
            "Yogendra Shastri, Dept. of Chemical Engineering, IIT Bombay discussed Energy consumption's crucial role in climate change and society development.",
            "Covered Sustainable Development Goals, challenges, and 12 principles of sustainable engineering with UN Sustainable growth examples.",
            "Dr. Umesh Mundlye, Director at OIKOS Water Management, spoke on Conservation of natural resources and Carbon sequestration.",
          ],
        },
        {
          dayTitle: "Day 9 (June 16): Carbon Farming",
          points: [
            "Mr. Ravin Kumar, Product Leader TCS Digital Farming Initiative, spoke on Carbon Farming and Potential Opportunities for Farmers and Agri value chain players.",
            "Discussed challenges in carbon farming and the need for sustainability in food production.",
          ],
        },
        {
          dayTitle: "Day 10 (June 17): Valedictory Function",
          points: [
            "Valedictory function graced by Dr. Abdul Moid, Director ERTL(W) Mumbai, STQC DTE, Ministry of Electronics & IT, Govt. of India.",
            "He briefed about how technology contributes in real life in the current pandemic situation.",
          ],
        },
      ],
      tools: ["AWS", "CLOUD COMPUTING", "SMART BOARD", "CARBON SEQUESTRATION TOOLS"],
      outcome: "Participants got an appropriate learning platform to enhance knowledge and skills about latest technologies like cloud computing and got exposure to relevant topics of the modern world like carbon neutrality and alternative solar energy.",
    },
    "2020-21": {
      title: "Information Technology for Sustainability: Blockchain & Data Science",
      duration: "13 Days",
      dates: "June 17-29, 2021",
      association: "ISTE, CSI Mumbai Chapter, Spoken tutorial IIT",
      mode: "Online",
      overview1: "TIMSCDR conducted a 2 week ISTE approved online STTP in association with CSI, Mumbai Chapter and Spoken tutorial, IIT from 17 – 29 June 2021. The theme was Information Technology for Sustainability: Blockchain Technology and Data Science.",
      overview2: "The STTP was inaugurated by Dr. Suresh Shan, Head – Innovation & Future Technologies BITS, Mahindra & Mahindra Financial Services Limited. He applauded the efforts taken by the Institute to train staff on the latest technology.",
      sessions: [
        {
          dayTitle: "Key Technical & Sustainability Sessions",
          points: [
            "Dr. Narendra Vaidya briefed about Geriatric Care and its significance, while Mr. Deepak Pareek spoke about food system transformation driven by data.",
            "Mr. Dinesh Kumar Singh discussed the digital era and the 5 main digital forces (mobility, big data, social media, cloud, AI & robotics).",
            "Mr. Jeeven Saini explained Blockchain in domains like banking and fintech. Mr. Abhishek Pandey elaborated on Cyber Security and common hacking scenarios.",
            "Deep Learning and Data Science in FMCG were discussed by Mr. Devesh Rajadhyax, Mr. Jacky Patel, and Mr. Satyajit Garewal.",
            "Mr. Awab Habib Fakih spoke on machine learning basics, and Dr. Deven Shah led a session on blockchain technology basics and bitcoin installation.",
          ],
        },
        {
          dayTitle: "Wellness & Hands-on Workshops",
          points: [
            "Celebrated International Yoga Day with a session by Mr. Chandan Mishra.",
            "Workshops on R, Python, and PHP were conducted in association with Spoken tutorial, IIT-Bombay with daily assignments.",
          ],
        },
      ],
      tools: ["BLOCKCHAIN", "PYTHON", "R", "PHP", "DATA SCIENCE TOOLS", "MACHINE LEARNING", "BITCOIN", "METAMASK"],
      outcome: "About 157 participants from all over India were certified. Participants got an appropriate online learning platform to enhance knowledge and skills during the COVID-19 pandemic.",
    },
    "2019-20": {
      title: "Information Technology for Sustainability",
      duration: "12 Days",
      dates: "June 15-26, 2020",
      association: "ISTE, Spoken Tutorial IIT-Bombay, CSI Mumbai",
      mode: "Online",
      overview1: "TIMSCDR organized for the first time its STTP online between 15-26 June, 2020 themed on 'Information Technology for Sustainability', approved by ISTE, New Delhi and Spoken Tutorial, IIT-Bombay.",
      overview2: "The two weeks STTP was inaugurated by Dr. Suresh Chandra Gupta, Honorary Head, CSI – Mumbai Chapter, who explained the various collaborative online programs and technology skill enhancement.",
      sessions: [
        {
          dayTitle: "Core Themes & Digital Adaptations",
          points: [
            "Ms. Rhea Pai conducted a session on 'Mindfulness in the COVID-19 Scenario' focusing on self-management and mindful leadership.",
            "Dr. Sangeeta Joshi explained the NAAC accreditation process, IQAC excellence, and Systematic Data Organization & Presentation.",
            "Mr. Awab Habib Fakih elucidated on design thinking and methods like Blue Ocean, Red Ocean, and Lotus Blossom Techniques.",
            "Dr. K. Ganapathy and Dr. Milind Antani detailed Telemedicine, TeleHealth models, and their vital applications during the pandemic.",
          ],
        },
        {
          dayTitle: "Emerging Tech & Wellness",
          points: [
            "Mr. Jasveer Singh covered IoT Applications in agriculture, and Mr. Ramaswamy Seshan discussed Agriculture amidst COVID-19.",
            "Dr. Deven Shah explained Blockchain Technology, Ethereum open-source platform, and AWS blockchain services.",
            "Mr. A.P. Gaurvadkar demonstrated online open-source tools (like OBS) to connect with students.",
            "Wellness sessions included Art of Living by Ms. Neeta Sharda, Yoga and Physiotherapy by Dr. Sharon Wu, and Team Building by Ms. Suman Pai.",
            "Hands-on workshop on Python 3.4.3 was conducted via Spoken tutorial, IIT-Bombay.",
          ],
        },
      ],
      tools: ["PYTHON", "BLOCKCHAIN", "IOT", "TELEMEDICINE PLATFORMS", "OBS", "ETHEREUM"],
      outcome: "Around 157 participants were certified. Participants gained an appropriate Online Learning platform to enhance knowledge during the pandemic of COVID-19, studying the Role of IT for sustainability and adapting to digital ecosystems.",
    },
    "2018-19": {
      title: "Information Technology for Sustainability",
      duration: "12 Days",
      dates: "June 17-28, 2019",
      association: "ISTE",
      mode: "Offline",
      overview1: "The two week ISTE approved STTP 'Information Technology for Sustainability' was inaugurated by Dr. Rajiv Desai, Hon. Treasurer, Computer Society of India, Mumbai Chapter.",
      overview2: "The program discussed how information technology plays a pivotal role in managing operations supporting economic, environmental, and social dimensions of sustainable growth.",
      sessions: [
        {
          dayTitle: "Technical Deep Dives & Data Science",
          points: [
            "Dr. Yogendra Shastri covered sustainability, footprint analysis of carbon/water, and life cycle assessment framework.",
            "5-day workshop on Data Science by Mr. Parag Kulkarni, Dr. Prachi Joshi, and Mr. Vinayak Jagtap covering ML algorithms, Python execution, and R data visualization.",
            "Mr. Lakshey Sehgal conducted a workshop on solar energy, rooftop solar PV systems, and shading analysis.",
          ],
        },
        {
          dayTitle: "Agriculture, Healthcare & Educational Excellence",
          points: [
            "Field visits to Sahayadri Farms and Sula Wines on June 21 to witness live functioning of processing and sustainable packaging.",
            "Mr. Vijay Yelmalle presented sustainable farming techniques via Aquaponics and Hydroponics. Dr. Lavesh Jadhav discussed human genetics and DNA tests.",
            "Educational sessions included Bloom's Taxonomy by Dr. Madhuri Mavinkurve, Voice Modulation by Ms. Niti Mathur, and Excellence for Sustainability by Ms. Suman Pai.",
          ],
        },
      ],
      tools: ["PYTHON", "R", "DATA SCIENCE", "MACHINE LEARNING", "SOLAR PV SYSTEMS"],
      outcome: "The two week STTP successfully enhanced faculty knowledge on sustainability, data science, solar energy systems, and excellence in education. Certificates were distributed by Dr. Vinita Gaikwad.",
    },
    "2017-18": {
      title: "Advanced Computing Techniques",
      duration: "13 Days",
      dates: "May 5-17, 2018",
      association: "ISTE",
      mode: "Offline",
      overview1: "Two week ISTE approved STTP on 'Advanced Computing Techniques', organized under the guidance of Director Dr. Vinita Gaikwad.",
      overview2: "The program mainly focused on Digital Marketing and the use of Information Technology in Agro – Healthcare Waste Management.",
      sessions: [
        {
          dayTitle: "Sustainability, Waste Management & Wellness",
          points: [
            "Inaugurated with a visit to Saguna Baug, Neral to learn about innovative farming methods, traditional/non-traditional agriculture, and carbon sequestration.",
            "May 7 featured Yoga by Mr. Ulhas Ramdhs Hegde, Investor Awareness by Mr. Manoj Sathe, and Kitchen Waste Management by Ms. Aprajita Singh & Ms. Mira Gohil.",
            "Mr. Vidhadhur Walawalkar conducted a lecture on Biomedical Waste Management, and Mr. Miling Chaudhari explained waste treatment via Biogas.",
          ],
        },
        {
          dayTitle: "Digital Marketing & AI",
          points: [
            "Six days of hands-on training on Digital Marketing (Google Adwords, PPC, SEO, Social Media Marketing, Google Analytics).",
            "Mr. Akshat Kadam from Sony Corporation Japan R&D conducted a lecture on 'Intuiting Artificial Intelligence' and Deep Learning applications.",
            "Statistical Analysis in Research was covered by Dr. Vaibhav Thakkar.",
          ],
        },
      ],
      tools: ["GOOGLE ADWORDS", "SEO TOOLS", "GOOGLE ANALYTICS", "AI"],
      outcome: "Two week STTP concluded with all participants successfully clearing 'Google AdWords Fundamentals' and 'Google AdWords Search' certifications. Faculty was equipped with knowledge of digital marketing, biomedical waste management, and AI.",
    },
    "2016-17": {
      title: "Advanced Computing Techniques",
      duration: "14 Days",
      dates: "April 29 - May 12, 2017",
      association: "ISTE",
      mode: "Offline",
      overview1: "Two week ISTE approved STTP on 'Advanced Computing Techniques' mainly focused upon DCS Switching Certification in Networking and use of Information Technology in Agriculture.",
      overview2: "Inaugurated by Dr. Dhananjay Kalbande, Chairman BOS – MCA, University of Mumbai, who motivated the faculty to use networking paradigms in providing sustainable agricultural solutions.",
      sessions: [
        {
          dayTitle: "Core IT Certifications",
          points: [
            "Six days hands on training on DCS Switching Certification from 2 – 8 May 2017. The program included network essentials, VLAN, spanning tree protocol, switch stacking, and routing.",
          ],
        },
        {
          dayTitle: "Agriculture & Soft Skills",
          points: [
            "Ms. Rhea Pai conducted an inspiring session on 'Creative Self at Work' and adapting in the VUCA world.",
            "Ms. Yukti K. Mehandiratta conducted 'Mantras to Manage the Millennial Generation' discussing power dressing and teaching styles.",
            "Dr. J. Adinarayana from IIT Mumbai discussed SMART farming technologies and the 'Role of ICTDTs in Agriculture'.",
            "Faculty visited Save Farms, Dhanau to learn about sustainable organic agricultural practices and rain water harvesting.",
          ],
        },
      ],
      tools: ["DCS SWITCHING", "NETWORKING TOOLS", "VLAN", "ROUTING"],
      outcome: "The STTP successfully concluded with faculty certified in DCS Switching and equipped with knowledge of networking and ICT applications in agriculture.",
    },
    "2015-16": {
      title: "Conduct of Research and Use of Information Technology",
      duration: "14 Days",
      dates: "May 18-31, 2016",
      association: "ISTE",
      mode: "Offline",
      overview1: "Organized two week ISTE approved STTP on 'Conduct of Research and Use of Information Technology' to continuously upgrade faculty research activities.",
      overview2: "The program planned for two days of hands-on advanced training on 'Internet of Things' along with sessions on mind management, stress management, and Yoga.",
      sessions: [
        {
          dayTitle: "Research Methodology & IP",
          points: [
            "Dr. G. S. Singh inaugurated the STTP and discussed avenues for IT application in research.",
            "Dr. Arun Pande covered 'Research and Research Translation using Information Technology'.",
            "Dr. Vinit Dongre explained formulating effective research, opportunities for IP, and the process of filing a patent.",
            "Research concepts and methodologies were further detailed by Dr. Rushikesh Joshi, Dr. Ashok Pathre, Dr. Urjaswala Vora, and Dr. Uday Khedkar.",
          ],
        },
        {
          dayTitle: "Technology & Wellness Workshops",
          points: [
            "Mr. Anand Khandare discussed the R Programming language for Statistical Analysis.",
            "Dr. Deven Shah explored Software Defined Networks (SDN).",
            "Two days of hands-on training on IoT was conducted by Mr. Deepak Gupta, building smart phone applications to control home automation using Raspberry Pi and relays.",
            "Sessions on Mandarin language, Yoga (Mrs. Kajol), Stress Management (Ms. Sandhya), and Mind Management (Mr. Hitesh).",
          ],
        },
      ],
      tools: ["IOT", "RASPBERRY PI", "R PROGRAMMING", "SDN", "SENSORS"],
      outcome: "Two week STTP concluded with faculty gaining comprehensive knowledge of research methodology, patent filing, and practical IoT hands-on experience.",
    }
  };

  // Timeline data for the sidebar matching the structure
  const timelineData = [
    {
      year: "2024-25",
      title: "Green AI & Sustainability",
      desc: "14-day STTP on Green IT practices, AI, and holistic wellness.",
      iconPath: "M13 10V3L4 14h7v7l9-11h-7z"
    },
    {
      year: "2023-24",
      title: "Agriculture & Healthcare",
      desc: "Focus on IT applications in agriculture and healthcare for Viksit Bharat.",
      iconPath: "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064"
    },
    {
      year: "2022-23",
      title: "Women Empowerment",
      desc: "Information Technology initiatives focused on women empowerment and health.",
      iconPath: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
    },
    {
      year: "2021-22",
      title: "Carbon Neutrality",
      desc: "AWS Cloud computing and achieving carbon neutrality through IT.",
      iconPath: "M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
    },
    {
      year: "2020-21",
      title: "Blockchain & Data Science",
      desc: "Online STTP covering digital transformations and Blockchain Technology.",
      iconPath: "M13 10V3L4 14h7v7l9-11h-7z"
    },
    {
      year: "2019-20",
      title: "IT for Sustainability (Online)",
      desc: "First online STTP discussing IT's role in sustainability during COVID-19.",
      iconPath: "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064"
    },
    {
      year: "2018-19",
      title: "Sustainability",
      desc: "Workshops on Data Science, ML algorithms, and Solar PV systems.",
      iconPath: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
    },
    {
      year: "2017-18",
      title: "Advanced Computing Techniques",
      desc: "Digital Marketing mastery and AI in Agro-Healthcare Waste Management.",
      iconPath: "M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
    },
    {
      year: "2016-17",
      title: "Advanced Computing Techniques",
      desc: "DCS Switching Certification and ICT applications in agriculture.",
      iconPath: "M13 10V3L4 14h7v7l9-11h-7z"
    },
    {
      year: "2015-16",
      title: "Research & IT",
      desc: "IoT hands-on building, Research Methodology, and SDN fundamentals.",
      iconPath: "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064"
    },
    {
      year: "2014-15",
      title: "Advance Computing Techniques",
      desc: "Big Data, Hadoop, GIS Remote Sensing, and Business Intelligence.",
      iconPath: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
    }
  ];

  // Carousel Image Array based on the uploaded image directory
const carouselImages = [
  "/STTP/DSC05516.JPG.crdownload.jpg",
  "/STTP/MCA09535.JPG.crdownload.jpg",
  "/STTP/MCA09594.JPG",
  "/STTP/MCA09718.JPG",
  "/STTP/MCA09801.JPG",
  "/STTP/sILENT HILL RESORT.jpeg",
  "/STTP/Swati research.jpeg",
  "/STTP/YOGA DAY.JPG",
  "/STTP/imgi_3_STTP-2025-3-scaled.webp",
  "/STTP/imgi_4_STTP-2025-1-1-scaled.webp",
  "/STTP/imgi_5_STTP-2024-scaled.webp",
  "/STTP/imgi_6_STTP-2025-2-1-scaled.webp",
  "/STTP/imgi_7_STTP-2024-Trip-scaled.webp",
  "/STTP/imgi_8_STTP-2024-Design-Thinking-scaled.webp",
  "/STTP/imgi_9_STTP-24-scaled.webp",
  "/STTP/imgi_10_STTP-24-1-scaled.webp",
  "/STTP/imgi_11_day-9-7.webp",
  "/STTP/imgi_12_day-6.webp",
  "/STTP/imgi_13_day-4-1.webp",
  "/STTP/imgi_14_day-9-1.webp",
  "/STTP/imgi_15_day6.webp",
  "/STTP/imgi_16_day-3.webp",
  "/STTP/imgi_17_day-9-brahma kumari.webp",
  "/STTP/imgi_18_DSC01480.webp",
  "/STTP/imgi_19_image005-1.webp",
  "/STTP/imgi_20_1654601262132-scaled.webp",
  "/STTP/imgi_21_DSC01507.webp",
  "/STTP/imgi_22_DSC01484.webp",
  "/STTP/imgi_23_image040.webp",
  "/STTP/imgi_24_image027.webp",
  "/STTP/imgi_25_GMC08062022_103959-scaled.webp",
  "/STTP/imgi_26_1654583420213-scaled.webp",
  "/STTP/imgi_27_image093.webp",
  "/STTP/imgi_28_image035.webp",
  "/STTP/imgi_29_IMG_20220608_133540-scaled.webp",
  "/STTP/imgi_30_image092.webp",
  "/STTP/imgi_31_image089.webp",
  "/STTP/imgi_32_image081.webp",
  "/STTP/imgi_33_image062.webp",
  "/STTP/imgi_34_image058.webp",
  "/STTP/imgi_35_image054.webp",
  "/STTP/imgi_36_image008-1.webp",
  "/STTP/imgi_37_sttp10-1.webp",
  "/STTP/imgi_38_sttp27.webp",
  "/STTP/imgi_39_sttp26.webp",
  "/STTP/imgi_40_sttp25.webp",
  "/STTP/imgi_41_sttp24.webp",
  "/STTP/imgi_42_sttp23.webp",
  "/STTP/imgi_43_sttp22.webp",
  "/STTP/imgi_44_sttp21.webp",
  "/STTP/imgi_45_sttp20.webp",
  "/STTP/imgi_46_sttp19-e1630569908802.webp",
  "/STTP/imgi_47_sttp18.webp",
  "/STTP/imgi_48_sttp17-1.webp",
  "/STTP/imgi_49_sttp16.webp",
  "/STTP/imgi_50_sttp15-e1630570049697.webp",
  "/STTP/imgi_51_sttp14-e1630570015321.webp",
  "/STTP/imgi_52_sttp12.webp",
  "/STTP/imgi_53_sttp11-e1630569987243.webp",
  "/STTP/imgi_54_sttp9.webp",
  "/STTP/imgi_55_sttp8.webp",
  "/STTP/imgi_56_sttp7-1.webp",
  "/STTP/imgi_57_sttp6.webp",
  "/STTP/imgi_58_sttp5.webp",
  "/STTP/imgi_59_sttp4.webp",
  "/STTP/imgi_60_Alumin3.webp",
  "/STTP/imgi_61_sttp2.webp",
  "/STTP/imgi_62_sttp1.webp",
  "/STTP/imgi_63_01-sttp-2020.webp",
  "/STTP/imgi_64_02-sttp-2020.webp",
  "/STTP/imgi_65_03-sttp-2020.webp",
  "/STTP/imgi_66_04-sttp-2020.webp",
  "/STTP/imgi_67_05-sttp-2020.webp",
  "/STTP/imgi_68_06-sttp-2020.webp",
  "/STTP/imgi_69_01-sttp-2017.webp",
  "/STTP/imgi_70_07-sttp-2020.webp",
  "/STTP/imgi_71_08-sttp-2020.webp",
  "/STTP/imgi_72_09-sttp-2020.webp",
  "/STTP/imgi_73_10-sttp-2020.webp",
  "/STTP/imgi_74_11-sttp-2020.webp",
  "/STTP/imgi_75_12-sttp-2020.webp",
  "/STTP/imgi_76_01-STTP-2019.webp",
  "/STTP/imgi_77_02-STTP-2019.webp",
  "/STTP/imgi_78_03-STTP-2019.webp",
  "/STTP/imgi_79_12-sttp-2018-1.webp",
  "/STTP/imgi_80_07-STTP-2019.webp",
  "/STTP/imgi_81_12-STTP-2019-1.webp",
  "/STTP/imgi_82_11-STTP-2019-1.webp",
  "/STTP/imgi_83_10-STTP-2019.webp",
  "/STTP/imgi_84_14-STTP-2018-1.webp",
  "/STTP/imgi_85_03-STTP-2019.webp",
  "/STTP/imgi_86_05-STTP-2019.webp",
  "/STTP/imgi_87_09-STTP-2019.webp",
  "/STTP/imgi_88_06-STTP-2019.webp",
  "/STTP/imgi_89_04-STTP-2019.webp",
  "/STTP/imgi_90_11-sttp-2018-1.webp",
  "/STTP/imgi_91_10-sttp-2018.webp",
  "/STTP/imgi_92_09-sttp-2018.webp",
  "/STTP/imgi_93_08-sttp-2018.webp",
  "/STTP/imgi_94_07-sttp-2016.webp",
  "/STTP/imgi_95_06-sttp-2018.webp",
  "/STTP/imgi_96_01-sttp-2018.webp",
  "/STTP/imgi_97_13-sttp-2018-1.webp",
  "/STTP/imgi_98_09-sttp-2017.webp",
  "/STTP/imgi_99_15-sttp-2018-1.webp",
  "/STTP/imgi_100_14-STTP-2019-1.webp",
  "/STTP/imgi_101_10-STTP-2017.webp",
  "/STTP/imgi_102_02-STTP-2017.webp",
  "/STTP/imgi_103_06-STTP-2017.webp",
  "/STTP/imgi_104_08-STTP-2017.webp",
  "/STTP/imgi_105_07-STTP-2017.webp",
  "/STTP/imgi_106_WhatsApp-Image-2022-07-05-at-9.31.38-PM-e1657082819771.webp",
  "/STTP/imgi_108_Website-Header-2023-1536x166.webp"
];

  const [activeYear, setActiveYear] = useState("2024-25");
  const [currentSlide, setCurrentSlide] = useState(0);

  const current = yearData[activeYear] || yearData["2024-25"]; 

  // Carousel Auto-play logic
  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % carouselImages.length);
    }, 3500); // Change image every 3.5 seconds

    return () => clearInterval(slideInterval);
  }, [carouselImages.length]);

  return (
    <>
      <Navbar />

      <PageHeader
        title="Short Term Training Programme"
        crumbs={[{ label: "Home", href: "/" }, { label: "Short Term Training Programme" }]}
      />
      
      <div className="fdp-page-root">
        
        <div className="fdp-page-container">
          
          {/* HERO SECTION */}
          <div className="fdp-hero-wrapper">
            <div className="fdp-hero-left">
              <div className="fdp-hero-text">
                Our Short Term Training Programmes (STTPs) are immersive experiences designed to provide in-depth 
                exposure to emerging technologies, sustainable practices, and holistic professional development. 
                These programs bridge the gap between academic curriculum and modern industry demands.
              </div>
              
              <div className="fdp-stats-container">
                <div className="fdp-stat-item">
                  <div className="fdp-stat-icon-wrapper">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path></svg>
                  </div>
                  <div className="fdp-stat-content">
                    <span className="fdp-stat-value">11+</span>
                    <span className="fdp-stat-label">STTPs Conducted</span>
                  </div>
                </div>
                <div className="fdp-stat-item">
                  <div className="fdp-stat-icon-wrapper">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                  </div>
                  <div className="fdp-stat-content">
                    <span className="fdp-stat-value">2014-25</span>
                    <span className="fdp-stat-label">Academic Years</span>
                  </div>
                </div>
                <div className="fdp-stat-item">
                  <div className="fdp-stat-icon-wrapper">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
                  </div>
                  <div className="fdp-stat-content">
                    <span className="fdp-stat-value">150+</span>
                    <span className="fdp-stat-label">Participants Benefited</span>
                  </div>
                </div>
                <div className="fdp-stat-item">
                  <div className="fdp-stat-icon-wrapper">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path></svg>
                  </div>
                  <div className="fdp-stat-content">
                    <span className="fdp-stat-value">Industry Relevant</span>
                    <span className="fdp-stat-label">Skills & Technologies</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* REPLACED STATIC ILLUSTRATION WITH AUTO-CAROUSEL */}
            <div className="fdp-hero-right">
              <div 
                className="fdp-hero-carousel" 
                style={{ 
                  position: 'relative', 
                  width: '100%', 
                  height: '350px', 
                  borderRadius: '16px', 
                  overflow: 'hidden',
                  boxShadow: '0 20px 40px -10px rgba(0, 0, 0, 0.15)',
                  backgroundColor: '#f1f5f9'
                }}
              >
                {carouselImages.map((imgSrc, idx) => (
                  <img 
                    key={idx}
                    src={imgSrc} 
                    alt={`STTP Highlight ${idx + 1}`}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover', 
                      opacity: currentSlide === idx ? 1 : 0,
                      transition: 'opacity 0.8s ease-in-out',
                      zIndex: currentSlide === idx ? 1 : 0
                    }}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* YEAR TABS */}
          <div className="fdp-year-nav">
            {years.map((year) => (
              <button
                key={year}
                type="button"
                className={
                  activeYear === year
                    ? "fdp-year-btn fdp-year-btn-active"
                    : "fdp-year-btn"
                }
                onClick={() => setActiveYear(year)}
              >
                {year}
              </button>
            ))}
          </div>

          {/* MAIN CONTENT & SIDEBAR */}
          <div className="fdp-main-grid">
            
            {/* Left Main Card */}
            <div className="fdp-main-card">
              <div className="fdp-main-title">{current.title}</div>

              {/* Meta info tags */}
              <div className="fdp-meta-grid">
                <div className="fdp-meta-item">
                  <span className="fdp-meta-icon">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                  </span>
                  <span className="fdp-meta-label">Duration:</span>
                  <span className="fdp-meta-value">{current.duration}</span>
                </div>

                <div className="fdp-meta-item">
                  <span className="fdp-meta-icon">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                  </span>
                  <span className="fdp-meta-label">Dates:</span>
                  <span className="fdp-meta-value">{current.dates}</span>
                </div>

                <div className="fdp-meta-item">
                  <span className="fdp-meta-icon">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
                  </span>
                  <span className="fdp-meta-label">Association:</span>
                  <span className="fdp-meta-value">{current.association}</span>
                </div>

                <div className="fdp-meta-item">
                  <span className="fdp-meta-icon">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"></path></svg>
                  </span>
                  <span className="fdp-meta-label">Mode:</span>
                  <span className="fdp-meta-value">{current.mode}</span>
                </div>
              </div>

              {/* Overview */}
              <div className="fdp-section">
                <div className="fdp-section-title">Overview</div>
                <div className="fdp-section-text">{current.overview1}</div>
                {current.overview2 && <div className="fdp-section-text">{current.overview2}</div>}
              </div>

              {/* Sessions */}
              <div className="fdp-section">
                <div className="fdp-section-title">Key Sessions / Topics Covered</div>
                <div className="fdp-session-list">
                  {current.sessions.map((session, idx) => (
                    <div key={idx} className="fdp-session-block">
                      <div className="fdp-session-day-title">
                        {session.dayTitle}
                      </div>
                      <ul className="fdp-session-ul">
                        {session.points.map((pt, i) => (
                          <li key={i} className="fdp-session-li">
                            {pt}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>

              {/* Tools */}
              <div className="fdp-section">
                <div className="fdp-section-title">Tools & Technologies Used</div>
                <div className="fdp-tools-row">
                  {current.tools.map((tool) => (
                    <span key={tool} className="fdp-tool-chip">
                      {tool}
                    </span>
                  ))}
                </div>
              </div>

              {/* Outcome (Text Only) */}
              <div className="fdp-outcome-box">
                <div className="fdp-outcome-text">
                  {current.outcome}
                </div>
              </div>
            </div>

            {/* Right Sidebar Timeline */}
            <div className="fdp-timeline-sidebar">
              <div className="fdp-timeline">
                {timelineData.map((item, index) => (
                  <div key={index} className="fdp-timeline-item">
                    <div className="fdp-timeline-icon">
                      <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                        <path d={item.iconPath}></path>
                      </svg>
                    </div>
                    <div className="fdp-timeline-content">
                      <div className="fdp-timeline-year">{item.year}</div>
                      <div className="fdp-timeline-title">{item.title}</div>
                      <div className="fdp-timeline-desc">{item.desc}</div>
                      <button className="fdp-view-details" onClick={() => setActiveYear(item.year)}>
                        View Details 
                        <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <path d="M5 12h14M12 5l7 7-7 7"></path>
                        </svg>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default STTPPrograms;